import { Form, useNavigation } from 'react-router'
import { Button } from './ui/button.tsx'
import {
	Dialog,
	DialogClose,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from './ui/dialog.tsx'
import { Icon } from './ui/icon.tsx'
import { StatusButton } from './ui/status-button.tsx'

interface ConfirmationDialogProps {
	trigger: React.ReactNode
	title: string
	description: string
	confirmText?: string
	cancelText?: string
	variant?: 'destructive' | 'default'
	formData?: Record<string, string>
	onConfirm?: () => void
}

export function ConfirmationDialog({
	trigger,
	title,
	description,
	confirmText = 'Confirm',
	cancelText = 'Cancel',
	variant = 'destructive',
	formData,
	onConfirm,
}: ConfirmationDialogProps) {
	const navigation = useNavigation()
	const isPending = navigation.state !== 'idle'

	return (
		<Dialog modal={true}>
			<DialogTrigger
				asChild
				onClick={(e: React.MouseEvent) => e.stopPropagation()}
			>
				{trigger}
			</DialogTrigger>
			<DialogContent>
				<DialogHeader>
					<DialogTitle className="flex items-center gap-2">
						{variant === 'destructive' && (
							<Icon
								name="question-mark-circled"
								className="text-destructive h-5 w-5"
							/>
						)}
						{title}
					</DialogTitle>
					<DialogDescription>{description}</DialogDescription>
				</DialogHeader>
				<DialogFooter>
					<DialogClose asChild>
						<Button variant="outline">{cancelText}</Button>
					</DialogClose>
					{formData ? (
						<Form method="POST" className="inline">
							{Object.entries(formData).map(([key, value]) => (
								<input key={key} type="hidden" name={key} value={value} />
							))}
							<StatusButton
								type="submit"
								variant={variant}
								status={isPending ? 'pending' : 'idle'}
								disabled={isPending}
							>
								{confirmText}
							</StatusButton>
						</Form>
					) : (
						<Button variant={variant} onClick={onConfirm}>
							{confirmText}
						</Button>
					)}
				</DialogFooter>
			</DialogContent>
		</Dialog>
	)
}
